<script setup lang="ts">

</script>

<template>
<svg width="143" height="204" viewBox="0 0 143 204" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M137.912 44.6366H124.092V58.4566H137.912V44.6366Z" fill="#8CC443"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M128.629 136.261C128.629 171.781 99.8342 204 64.3147 204C28.7952 204 0 171.781 0 136.261C0 91.7897 51.5672 51.691 64.3147 0C70.2965 24.1747 84.7353 45.7917 98.4315 66.5424H84.5703V82.7138H100.742V102.846H80.6099V122.978H100.742V102.846H120.09C125.288 113.86 128.629 124.916 128.629 136.261ZM111.261 168.769C101.319 177.886 88.4481 183.579 74.3806 183.579C42.904 183.579 17.3678 155.073 17.3678 123.596C17.3678 118.563 18.1104 113.613 19.4305 108.704C15.3051 117.697 12.7062 126.69 12.7062 135.89C12.7062 165.964 37.0872 193.191 67.1199 193.191C85.3129 193.191 101.402 183.249 111.261 168.769Z" fill="#2DA9E0"/>
<path d="M122.73 101.979H142.079V82.6726H122.73V101.979Z" fill="#F1A421"/>
<path d="M106.559 65.1397V81.3112H122.73V65.1397H106.559Z" fill="#2DA9E0"/>
</svg>

</template>

<style lang="scss" scoped>

</style>